module.exports = __webpack_public_path__ + "media/images/icons/flags/CO-50c47e82e171733d294e3d27d9479a5d.svg";